<template>
  <svg class="video-control play" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
    <path d="M1576 927l-1328 738q-23 13-39.5 3t-16.5-36v-1472q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z" fill="#fff"/>
  </svg>
</template>


<script>
export default {
  name: 'SimplePlayIcon',
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// SimplePlayIcon.vue?d6be076c